// extracted by mini-css-extract-plugin
module.exports = {"main":"app-layout__main--_0y5oZn"};